export default {
  getAffiliate(state) {
    return state.affiliate;
  },
  getAffiliates(state) {
    return state.affiliates;
  },
  getUnvaluedAffiliates(state) {
    return state.unvaluedAffiliates;
  },
};
